export default {
  namespaced: true,

  getters: {
    elements: (state, getters, rootState, rootGetters) => element => {
      let components = rootGetters['columnModule/elements'](element).components
      return Object.prototype.hasOwnProperty.call(element, 'component') ? components[element.component] : components
    },
    index: (state, getters) => (element, id) => getters.elements(element).findIndex(component => component.id == id),
    id: (state, getters) => (element, id = 'id') => getters.elements(element)[id],
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    content: (state, getters) => element => getters.elements(element).content,
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    assets: (state, getters) => element => getters.elements(element).assets,
    background: (state, getters) => element => getters.elements(element).background,
    rows: (state, getters) => element => getters.elements(element).content.tabs[element.componentSection].content.rows,
    properties: (state, getters) => element => getters.elements(element).properties
  },
  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'componentModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'componentModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'componentModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'componentModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}
